export default __webpack_public_path__ + "static/media/homeIntroPictureFrame.fc42b493.svg";